import React, { useState } from 'react';

import UbiquitiSitesCards from '@totem/components/ubiquiti/sites/UbiquitiSitesCards';
import UbiquitiSitesContainer from '@totem/components/ubiquiti/sites/UbiquitiSitesContainer';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const UbiquitiSitesPage = () => {
  const [totalRecords, setTotalRecords] = useState<number>(0);

  return (
    <ContentLayout>
      <InputContainer
        componentKey={'dashboard.ubiquitiSites'}
        componentLabel={'Portfolio: Ubiquiti Sites'}
        filterConfig={[]}
        useUrlParams
        defaultSort={{
          field: 'device.displayName',
          direction: 'ascend',
        }}
      >
        <UbiquitiSitesContainer onRecordTotalChanged={setTotalRecords}>
          <IBCard
            isCovered
            title={'Ubiquiti Sites'}
            extra={<RecordCountBadge count={totalRecords} />}
          >
            <UbiquitiSitesCards />
          </IBCard>
        </UbiquitiSitesContainer>
      </InputContainer>
    </ContentLayout>
  );
};

export default UbiquitiSitesPage;
